@if (canEdit) {
  <div ngbDropdown class="dropdown">
    <a id="overflowMenu" class="overflow-menu-icon" ngbDropdownToggle>
      <i class="icon-more-13px icon-rotate-90"></i>
    </a>
    @if (context ==='flight-question-section') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="resetSection()">Reset Flight Section</a></li>
      </ul>
    }
    @if (context === 'general-question-section') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="resetGeneralQuestion()">Reset General Questions Section</a></li>
      </ul>
    }
    @if (context === 'notes-question-section') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="resetSection()">Reset Notes Section</a></li>
      </ul>
    }
    @if (context === 'flight-question' || context === 'notes-question' || context === 'followup-question' || context  === 'involvement-question' || context === 'group-question') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu"
        >
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()">Remove question</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'flight-followup-question') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()" [class.disabled]="isDisabled">Remove question</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'notes-followup-question') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()" [class.disabled]="isDisabled">Remove question</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'general-question') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()" [class.disabled]="isDisabled">Remove question</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'general-question-dropdown') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()" [class.disabled]="isDisabled">Remove question</a></li>
        <li><a ngbDropdownItem (click)="addAnswer()">Add answer</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'followup-question-dropdown'
      || context === 'involvement-question-dropdown' || context === 'group-question-dropdown') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()">Remove question</a></li>
        <li><a ngbDropdownItem (click)="addAnswer()">Add answer</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'flight-question-dropdown'
      || context === 'flight-followup-question-dropdown') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()" [class.disabled]="isDisabled">Remove question</a></li>
        <li><a ngbDropdownItem (click)="addAnswer()" [class.disabled]="isDisabled">Add answer</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'answer') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editAnswer()">Edit answer</a></li>
        <li><a ngbDropdownItem (click)="sortAnswer()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeAnswer()" [class.disabled]="isDisabled">Remove answer</a></li>
        <li><a ngbDropdownItem (click)="addQuestion()">Add followup question</a></li>
        @if (canAdminFillOutReport) {
          <li><a ngbDropdownItem (click)="addTemplate()">Add template</a></li>
        }
      </ul>
    }
    @if (context === 'answer-for-flight') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editAnswer()">Edit answer</a></li>
        <li><a ngbDropdownItem (click)="sortAnswer()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeAnswer()" [class.disabled]="isDisabled">Remove answer</a></li>
        <li><a ngbDropdownItem (click)="addQuestion()">Add followup question</a></li>
        @if (canAdminFillOutReport) {
          <li><a ngbDropdownItem (click)="addTemplate()">Add template</a></li>
        }
      </ul>
    }
    @if (context === 'involvement') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit involvement</a></li>
        <li><a ngbDropdownItem (click)="removeGroupType()">Remove involvement</a></li>
        <li><a ngbDropdownItem (click)="addGroupDetail()">Add field</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'involvement-detail') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="removeInvolvementDetail()">Remove field</a></li>
      </ul>
    }
    @if (context === 'question-involvement') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()" [class.disabled]="isDisabled">Remove question</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'question-group') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editMetaData()">Edit question</a></li>
        <li><a ngbDropdownItem (click)="sortQuestion()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeQuestion()" [class.disabled]="isDisabled">Remove question</a></li>
        <li><a ngbDropdownItem (click)="manageTags()">Manage tags</a></li>
      </ul>
    }
    @if (context === 'answer-involvement' || context === 'group-involvement') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu"
        >
        <li><a ngbDropdownItem (click)="editGroup()">Edit involvement</a></li>
        <li><a ngbDropdownItem (click)="addQuestion()">Add followup question</a></li>
        @if (canAdminFillOutReport) {
          <li><a ngbDropdownItem (click)="addTemplate()">Add template</a></li>
        }
      </ul>
    }
    @if (context === 'answer-group' || context === 'group-answer') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="addQuestion()">Add followup question</a></li>
        @if (canAdminFillOutReport) {
          <li><a ngbDropdownItem (click)="addTemplate()">Add template</a></li>
        }
      </ul>
    }
    @if (context === 'multi-limited') {
      <ul ngbDropdownMenu aria-labelledby="overflowMenu">
        <li><a ngbDropdownItem (click)="editAnswer()">Edit answer</a></li>
        <li><a ngbDropdownItem (click)="sortAnswer()">Edit sort order</a></li>
        <li><a ngbDropdownItem (click)="removeAnswer()" [class.disabled]="isDisabled">Remove answer</a></li>
      </ul>
    }
  </div>
}